import { Stack } from "@mui/material";
import { Icon } from "components/Icon";
import React from "react";
import { cn } from "utils/styling";

type EpcFileUploadBaseProps = {
  className?: string;
  file: File;
  message: string;
  progressComponent?: null | React.ReactNode;
  title: string;
};

export const EpcFileUploadBase = ({ className, file, message, progressComponent, title }: EpcFileUploadBaseProps) => {
  return (
    <Stack alignItems="stretch" className={cn("w-full gap-6", className)} direction="column">
      <h2 className="font-ds-headline-lg">{title}</h2>
      <Stack className="w-full gap-3 rounded-ds-0-5x border bg-white px-3 py-2 border-ds-subtle">
        <Icon iconName="CertificateIcon" size="sm" />
        <p className="min-w-0 flex-1 truncate text-left font-ds-body-regular-md">{file.name}</p>
      </Stack>
      <p className="w-full text-left text-lds-foreground-muted font-ds-body-regular-md">{message}</p>
      {progressComponent}
    </Stack>
  );
};
